import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const LOAN_ELIGIBILITY_REPORT_URL = `${API_URL}/loan-eligibility-requests`

export const service = {
  getLoanEligibilityReport: (params: ParamsModel) => {
    return axios.get(LOAN_ELIGIBILITY_REPORT_URL, {params})
  },
  getLoanEligibilityReportDetail: (id: string) => {
    return axios.get(`${LOAN_ELIGIBILITY_REPORT_URL}/${id}`)
  },
  updateLoanEligibilityStatus: (id: string, status: string) => {
    return axios.patch(`${LOAN_ELIGIBILITY_REPORT_URL}/${id}/status`, {status})
  },
}
